export const MOBILE_HISTORY_INFO_TYPES = {
    DATE: 'date',
    POSITION: 'position',
    TRANSACTION: 'transaction',
} as const
